import React, { ChangeEvent, ReactElement, useState } from "react";
import { Button, FormControl } from "react-bootstrap";
import { useProjects } from "./ProjectContext";
import { ProjectTask } from "./ProjectTask";
import { ProjectTaskComment } from "./ProjectTaskComment";

interface IProps {
	comment?: ProjectTaskComment;
	task: ProjectTask;
	onSave?: (comment: ProjectTaskComment) => void;
}

export const ProjectTaskCommentForm = (props: IProps): ReactElement => {
	const [comment, setComment] = useState(
		props.comment ? props.comment : new ProjectTaskComment(),
	);
	const projectContext = useProjects();

	const submitComment = () => {
		if (!comment.id) {
			projectContext.createProjectTaskComment!(props.task, comment);
			setComment(new ProjectTaskComment());
		} else {
			projectContext.updateProjectTaskComment!(props.task, comment);
		}

		if (props.onSave) {
			props.onSave(comment);
		}
	};

	const handleChangeComment = (ev: ChangeEvent<HTMLInputElement>) => {
		comment.comment = ev.target.value;
		setComment({ ...comment });
	};

	return (
		<>
			<FormControl
				as="textarea"
				value={comment.comment}
				onChange={handleChangeComment}
			/>
			<Button
				className="mt-2"
				onClick={submitComment}
				disabled={!comment.comment.length}
			>
				Save
			</Button>
		</>
	);
};
